// Tiny formatter shared by InsightCard, InsightTable and InsightList.
// Backend tells us the format ("currency" | "number" | "percent");
// frontend just renders it. No locale logic beyond Arabic numerals.

const _currencyFmt = new Intl.NumberFormat('ar-SA', {
  style: 'currency',
  currency: 'SAR',
  maximumFractionDigits: 2,
});

const _numberFmt = new Intl.NumberFormat('ar-SA', {
  maximumFractionDigits: 2,
});

export function formatInsightValue(value, format) {
  if (value === null || value === undefined || value === '') return '—';
  if (format === 'currency') {
    const n = Number(value);
    return Number.isFinite(n) ? _currencyFmt.format(n) : String(value);
  }
  if (format === 'percent') {
    const n = Number(value);
    return Number.isFinite(n) ? `${(n * 100).toFixed(1)}%` : String(value);
  }
  if (format === 'number') {
    const n = Number(value);
    return Number.isFinite(n) ? _numberFmt.format(n) : String(value);
  }
  if (typeof value === 'object') return JSON.stringify(value);
  return String(value);
}
